import { BaseElementWithoutShadowDOM } from '@theme/base-element'

export class ShopTheLookElement extends BaseElementWithoutShadowDOM {
  constructor() {
    super(...arguments)

    this.open = false
  }
  static get properties() {
    return {
      open: {
        attribute: 'open',
        reflect: true,
      },
    }
  }

  get modal() {
    return this.renderRoot?.querySelector('.modal') ?? null
  }

  get shopTheLookBtn() {
    return this.renderRoot?.querySelector('.shop-the-look-btn') ?? null
  }

  get modalCloseBtn() {
    return (
      this.renderRoot ?? document.createDocumentFragment()
    ).querySelectorAll('.modal-close-btn')
  }

  firstUpdated() {
    this.shopTheLookBtn?.addEventListener('click', () => {
      this.toggle(true)
    })

    for (const btn of this.modalCloseBtn) {
      btn.addEventListener('click', () => {
        this.toggle(false)
      })
    }
  }

  toggle(value) {
    this.open = value

    if (value) {
      this.modal?.setAttribute('open', 'true')
    } else {
      this.modal?.removeAttribute('open')
    }
  }
}

customElements.define('shop-the-look', ShopTheLookElement)
